import { Link } from 'react-router';

import InCourseExperienceHeader from 'my-components/OnlineCourse/InCourseExperience/InCourseExperienceHeader';

import { StudentCoursePageContentsWrapper } from './StudentCoursePageCommon';

import Typography from '@mui/material/Typography';

export default function StudentCoursePageNotFound({ course, drawerOpen, onToggleDrawer }) {
  return (
    <>
      <InCourseExperienceHeader
        drawerOpen={drawerOpen}
        onToggleDrawer={onToggleDrawer}
        title="Uh oh..."
        titleVariant="h6"
      />
      <StudentCoursePageContentsWrapper>
        <Typography align="center" gutterBottom variant="h5">
          That part of the {course?.code} course you were looking is no longer available
        </Typography>
        <Typography align="center" variant="subtitle2">
          <Link to="..">Return to Overview</Link>
        </Typography>
      </StudentCoursePageContentsWrapper>
    </>
  );
}
